import { z } from 'zod'
export const ingredientSchema = z.object({ id: z.string().min(1), name: z.string().min(1), unit: z.enum(['g', 'ml', 'st', 'kg', 'l']), priceOre: z.number().finite().nonnegative() })
export const recipeLineSchema = z.object({ ingredientId: z.string().min(1), amount: z.number().finite().positive() })
export function recipeCostOre(recipe: unknown, ingredients: z.infer<typeof ingredientSchema>[]): number | null {
  const parsed = z.array(recipeLineSchema).safeParse(recipe)
  if (!parsed.success || !parsed.data.length) return null
  let total = 0
  for (const line of parsed.data) {
    const ingredient = ingredients.find((row) => row.id === line.ingredientId)
    if (!ingredient) return null
    const divisor = ingredient.unit === 'g' || ingredient.unit === 'ml' ? 1000 : 1
    total += (line.amount / divisor) * ingredient.priceOre
  }
  return Math.round(total)
}
